import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Logo from 'assets/img/guryouLogos/gyLogo09.png';
import { Icon } from './shared';

const Footer = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const content = [
    {
      title: t('FOOTER.discover'),
      actions: [
        {
          label: t('FOOTER.book'),
          action: () => history.push('/book'),
        },
        {
          label: t('FOOTER.video'),
          action: () => history.push('/video'),
        },
        {
          label: t('FOOTER.downloadApp'),
        },
      ],
    },
    {
      title: t('FOOTER.business'),
      actions: [
        {
          label: t('FOOTER.registerBusiness'),
          action: () => window.location.replace('https://guryou.biz/'),
        },
      ],
    },
    {
      title: 'Guryou',
      actions: [
        {
          label: t('FOOTER.about'),
          action: () => history.push('/about'),
        },
        {
          label: t('FOOTER.contactUs'),
        },
        {
          label: t('FOOTER.terms'),
          action: () => window.location.replace('https://www.iubenda.com/terms-and-conditions/8084171'),
        },
        {
          label: t('FOOTER.privacyPolicy'),
          action: () => window.location.replace('https://www.iubenda.com/privacy-policy/39480488'),
        },
        {
          label: t('FOOTER.cookiePolicy'),
          action: () => window.location.replace('https://www.iubenda.com/privacy-policy/39480488/cookie-policy'),
        },
      ],
    },
  ];

  return (
    <footer
      className="relative overflow-hidden"
      style={{
        backgroundColor: 'var(--feel-primary)',
        backgroundImage: 'linear-gradient(135deg, var(--feel-primary) 0%, var(--feel-primary-dark) 100%)',
      }}
    >
      {/* Decorative pattern overlay */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `radial-gradient(circle at 25% 25%, white 2px, transparent 2px),
                           radial-gradient(circle at 75% 75%, white 2px, transparent 2px)`,
          backgroundSize: '50px 50px',
        }}
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo Section */}
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center mb-6">
              <img src={Logo} className="h-10 w-auto" alt="Guryou Logo" />
            </a>
            <p className="text-white text-sm leading-relaxed max-w-xs opacity-90">
              {t('FOOTER.description', 'Discover the best wellness centers and professionals near you.')}
            </p>
          </div>

          {/* Navigation Sections */}
          {content.map(item => (
            <div key={item.title} className="space-y-4">
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider">{item.title}</h3>
              <ul className="space-y-3">
                {item.actions.map(action => (
                  <li key={action.label}>
                    <button
                      onClick={action.action}
                      className="text-white hover:text-gray-200 text-sm transition-colors duration-200 block opacity-90 hover:opacity-100"
                    >
                      {action.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white border-opacity-20 pt-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            {/* Copyright */}
            <div className="text-sm text-white mb-4 md:mb-0 opacity-90">
              © {new Date().getFullYear()} Guryou. {t('FOOTER.copyright', 'All rights reserved.')}
            </div>

            {/* Social Media Links */}
            <div className="flex space-x-6">
              <a
                href="https://www.facebook.com/guryou/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-200 transition-colors duration-200 opacity-80 hover:opacity-100"
                aria-label="Facebook"
              >
                <Icon name="facebook" size="md" />
              </a>
              <a
                href="https://www.instagram.com/guryou_official/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-200 transition-colors duration-200 opacity-80 hover:opacity-100"
                aria-label="Instagram"
              >
                <Icon name="instagram" size="md" />
              </a>
              <a
                href="https://twitter.com/guryou"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-200 transition-colors duration-200 opacity-80 hover:opacity-100"
                aria-label="Twitter"
              >
                <Icon name="twitter" size="md" />
              </a>
              <a
                href="https://www.linkedin.com/company/gy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-200 transition-colors duration-200 opacity-80 hover:opacity-100"
                aria-label="LinkedIn"
              >
                <Icon name="linkedin" size="md" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
